import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box,Typography} from '@mui/material';
import FieldView from 'core/components/layout/FieldView';
import {setStockorderSorting} from 'store/slice/ManufSlice';

export default function StockorderListTableHeader(){
  const dispatch = useDispatch();
  const {sorting} = useSelector((state) => state.manufslice.stockorderDashboard);
  
  const handleColumnClick = (column) => {
  const currentSorting = sorting.column === column ? !sorting.asc : true;
    dispatch(setStockorderSorting({ column, asc: currentSorting }));     
  }
    return (
      
      <Grid container direction="row" sx={{ justifyContent: "flex-start", alignItems: "center", width: '100%', padding: 1, backgroundColor: 'primary.lighter' }}>

            {/* <HEADER - CELLS/> */}
                        <Grid item lg={2} md={2} sm={2} xs={2} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('partyname')}> # </Typography></Grid>
                        <Grid item lg={6} md={6} sm={6} xs={6} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('partyname')}> Party </Typography></Grid>
                        <Grid item lg={2} md={2} sm={2} xs={2} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('orderstatusname')}> Status</Typography></Grid>
                        
      </Grid>
      
    )
}